import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

// Contrasenya de l'àrea privada - CANVIA AQUESTA CONTRASENYA
const ADMIN_PASSWORD = 'gatets123';

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Comprovar si la sessió està guardada
    const session = localStorage.getItem('gats_session');
    if (session === 'authenticated') {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const login = async (password) => {
    if (password === ADMIN_PASSWORD) {
      localStorage.setItem('gats_session', 'authenticated');
      setIsAuthenticated(true);
      return true;
    }
    throw new Error('Contrasenya incorrecta');
  };

  const logout = () => {
    localStorage.removeItem('gats_session');
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
